<template>
    <div class="preloader main-preloader">
        <img src="/images/preloader.svg"/>
    </div>
</template>

<script>
    export default {
        name: 'Preloader'
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/preloader.vue